








import { Component, Prop, Vue } from "vue-property-decorator";

@Component
export default class CzLink extends Vue {
  @Prop({ type: [String, Object], default: "" }) to!: string | object;
  @Prop({ type: String, default: "" }) href!: string;
}
